import React, { useEffect, useState } from 'react'
import classes from './scan.module.scss'
import { useForm } from 'react-hook-form'
import { useDispatch} from 'react-redux'
import { ScanCompleted } from '../../store/reducers/ScanReducer/RegistrationScanReducer'
import { laborantService } from '../../api/laborantService'
import { toast } from 'react-toastify'

const Scan = () => {
    const dispatch = useDispatch()

    const [scan, setScan] = useState({
      "status": '',
      "quantityMaterial": '',
      "research": '',
      "id": '',
    })

    const [activeButton, setActiveButton] = useState('scan');

    const {
        register,
        handleSubmit
    } =useForm()

    const onSubmit = async(data) =>{
      if(activeButton === 'scan'){
        try{
        let id = ((eval('({obj:' + data.afterRegisterScan + '})')).obj)?.directionId
        if(id){
          await laborantService.getDirection(id).then(res=>{
            if(res?.data){
              setScan({
                "status": res?.data.status,
                "quantityMaterial": res?.data.quantityMaterial,
                "research": res?.data.research,
                "id": id
              })
            }
          })
        }
        } catch (e) {
          toast.error('Скануйте Qr-code!')
        }
      } else if (activeButton === 'id'){
        try{
          let id = data.afterRegisterScan
          if(id){
            await laborantService.getDirection(id).then(res=>{
              if(res?.data){
                setScan({
                  "status": res?.data.status,
                  "quantityMaterial": res?.data.quantityMaterial,
                  "research": res?.data.research,
                  "id": id
                })
              }
            })
          }
          } catch (e) {
            toast.error('Скерування не існує або введений некоректно ID!')
          }
      }
    }

    

    useEffect(()=>{
      if (scan.research !== ''){
        dispatch(ScanCompleted({credential: scan}))
      }
    },[scan])

  return (
    <div className={classes.container}>
      <div>
      <button
          className={activeButton === 'scan' ? classes.selectButton__active : classes.selectButton}
          onClick={() => setActiveButton('scan')}
          type="button"
        >
          Сканування QR-code
        </button>
        <button
          className={activeButton === 'id' ? classes.selectButton__active : classes.selectButton}
          onClick={() => setActiveButton('id')}
          type="button"
        >
          Пошук за ID
        </button>
      </div>
      {activeButton === 'scan' &&
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
          <label className={classes.form__label}>Скануйте скерування</label>
          <input className={classes.form__input} placeholder='Скануйте QR-code' {...register('afterRegisterScan')}/>
          <button className={classes.form__button} type='submit'>Продовжити</button>
        </form>
      }
      {activeButton === 'id' &&
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
          <label className={classes.form__label}>Введіть ID скерування</label>
          <input className={classes.form__input} placeholder='Введіть ID скерування' {...register('afterRegisterScan')}/>
          <button className={classes.form__button} type='submit'>Продовжити</button>
        </form>
      }
    </div>
  )
}

export default Scan